//#region IMPORT
import React, { useEffect } from 'react';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
import { getColumnDefs1 } from './SAT_BASIC_06_ColumnDefs';
import { useSelector } from 'react-redux';

function SAT_BASIC_06(props) {
  const gridRef1 = props.gridRef;
  const columnDefs = getColumnDefs1(props);
  const searchInfo = useSelector((state) => state.SearchInfo);

  //#region AuthButton 이벤트

  useEffect(() => {
    const {
      filterClick6,
      searchClick6,
      addClick6,
      saveClick6,
      printClick6,
      validateSelection,
      setFilterClick6,
      setSearchClick6,
      setAddClick6,
      setSaveClick6,
      setPrintClick6,
      ResetLogicAll,
      SearchLogic1,
      SaveLogic1,
      PrintLogic1,
      setChangedRowData1,
    } = props;

    if (filterClick6) {
      if (!validateSelection()) {
        setFilterClick6(false);
        return;
      }

      gridRef1.current.api.setQuickFilter(searchInfo.searchText);
      setFilterClick6(false);
    }
    if (searchClick6) {
      ResetLogicAll();
      if (!validateSelection()) {
        setSearchClick6(false);
        return;
      }

      SearchLogic1();
      setSearchClick6(false);
    }
    if (addClick6) {
      if (!validateSelection()) {
        setAddClick6(false);
        return;
      }

      GridFunctions.addClick(gridRef1, setChangedRowData1);
      setAddClick6(false);
    }
    if (saveClick6) {
      if (!validateSelection()) {
        setSaveClick6(false);
        return;
      }

      SaveLogic1();
      setSaveClick6(false);
    }

    if (printClick6) {
      if (!validateSelection()) {
        setPrintClick6(false);
        return;
      }

      PrintLogic1();
      setPrintClick6(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.filterClick6,
    props.searchClick6,
    props.addClick6,
    props.saveClick6,
    props.deleteClick6,
    props.printClick6,
  ]);

  //#endregion
  return (
    <React.Fragment>
      <BusinessGridCommon
        getRowId={(params) => {
          return params.data.no;
        }}
        deleteYn1={'N'}
        gridRef={gridRef1}
        columnDefs={columnDefs}
        rowData={props.rowData1}
        setChangedRowData={props.setChangedRowData1}
        setSelectedRowData={props.setSelectedRowData1}
        flex={1}
        title1="교육관리(교육별)"
        addYn1="N"
        printYn1="N"
        addClick1={() => {
          if (!props.validateSelection()) return;

          GridFunctions.addClick(gridRef1, props.setChangedRowData1);
        }}
        refreshClick1={() => {
          if (!props.validateSelection()) return;

          props.SearchLogic1();
        }}
        deleteClick1={(e) => {
          if (!props.validateSelection()) return;

          const newRowExists = props.selectedRowData1.some(
            (row) => row.newYn === 'Y'
          );

          if (!newRowExists) {
            props.MarkedForDeletion1(props.selectedRowData1);
          } else {
            props.NewYnErrorMsg();
          }
        }}
        onCellClicked={(e) => {
          const gridApi = gridRef1.current.api;
          const clickedRowIndex = e.rowIndex;
          const clickedColumn = e.column?.getColId();

          const isCheckboxClick = e.event?.target?.type === 'checkbox';
          const isEditableCell = e.colDef?.editable === true;

          if (!isCheckboxClick) {
            gridApi.ensureIndexVisible(clickedRowIndex, 'middle');

            // 편집 가능한 셀인 경우 편집 모드로 진입
            if (isEditableCell) {
              const copied = JSON.parse(JSON.stringify(e.data));
              props.handleRowSelection(copied, clickedRowIndex);

              gridApi
                .getDisplayedRowAtIndex(clickedRowIndex)
                ?.setSelected(true, false);

              // 편집 모드로 진입
              gridApi.startEditingCell({
                rowIndex: clickedRowIndex,
                colKey: clickedColumn,
              });
            } else {
              gridApi.setFocusedCell(clickedRowIndex, 'SHE_GUBUN');

              const copied = JSON.parse(JSON.stringify(e.data));
              props.handleRowSelection(copied, clickedRowIndex);

              gridApi
                .getDisplayedRowAtIndex(clickedRowIndex)
                ?.setSelected(true, false);
            }
          }
        }}
        onSelectionChanged={() => {
          const gridApi = gridRef1.current?.api;
          if (!gridApi) return;

          const selectedNodes = gridApi.getSelectedNodes();
          const selectedData = selectedNodes.map((n) => n.data);

          // selectedRowNosRef 업데이트 (GridCheckBoxFunction과 동기화)
          props.selectedRowNosRef.current = new Set(
            selectedData.map((r) => r.no)
          );

          props.setSelectedRowData1(selectedData);
        }}
      />
    </React.Fragment>
  );
}

export default SAT_BASIC_06;
